var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aha-loading-dots",class:`aha-loading-dots--${_vm.size} aha-loading-dots--${_vm.variant}`})
}
var staticRenderFns = []

export { render, staticRenderFns }